const nomina = Object.freeze([
  { id: "S", value: "Si" },
  { id: "N", value: "No" },
]);

export { nomina };
